/**
 * Detects if a string looks like encrypted data (base64 with colons pattern: iv:tag:ciphertext)
 */
function looksEncrypted(value) {
  if (!value || typeof value !== 'string') return false;
  // Encrypted fields follow pattern: base64:base64:base64
  return /^[A-Za-z0-9+/=]{10,}:[A-Za-z0-9+/=]{10,}:[A-Za-z0-9+/=]+$/.test(value);
}

/**
 * Safely returns a displayable patient name, handling:
 * - name field vs first_name/last_name
 * - encrypted/garbled strings
 * - missing data
 */
export function getPatientDisplayName(patient) {
  if (!patient) return 'Unknown Patient';

  // Try name field first
  if (patient.name && !looksEncrypted(patient.name)) {
    return patient.name;
  }

  // Try first_name + last_name
  const first = patient.first_name && !looksEncrypted(patient.first_name) ? patient.first_name : '';
  const last = patient.last_name && !looksEncrypted(patient.last_name) ? patient.last_name : '';
  const fullName = `${first} ${last}`.trim();

  if (fullName) return fullName;

  // Fallback to patient_number or ID
  return patient.patient_number || `Patient ${(patient.id || '').slice(0, 8)}`;
}

/**
 * Safely returns a displayable value, masking encrypted strings
 */
export function safeDisplayField(value, fallback = '—') {
  if (!value || typeof value !== 'string') return fallback;
  if (looksEncrypted(value)) return fallback;
  return value;
}
